import { AvatarModule } from 'primeng/avatar';
import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';


import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';



import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TimelineModule } from 'primeng/timeline';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { SharedModule } from 'src/app/shared/shared.module';
import { DataViewModule } from "primeng/dataview";
import { SfcDashboardClientComponent } from './sfc-dashboard-client/sfc-dashboard-client.component';
import { SfcDashboardServiceComponent } from './sfc-dashboard-service/sfc-dashboard-service.component';
import { SfcDashboardAdminComponent } from './sfc-dashboard-admin/sfc-dashboard-admin.component';
import { DashboardHomeComponent } from './dashboard-home.component';
import { PanelModule } from 'primeng/panel';
import { DashboardRoutingModule } from './dashboard.routing.module';
import { NgxGaugeModule } from 'ngx-gauge';
import { RatingModule } from 'primeng/rating';
import { ChartModule } from 'primeng/chart';
import { KnobModule } from 'primeng/knob';
import { ScUserMessageModule } from 'src/app/features/sc-user-message/sc-user-message.module';


registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
    declarations: [DashboardHomeComponent, SfcDashboardClientComponent, SfcDashboardServiceComponent, SfcDashboardAdminComponent],
    exports: [DashboardHomeComponent, SfcDashboardClientComponent, SfcDashboardServiceComponent, SfcDashboardAdminComponent],
    imports: [FormsModule,
            ReactiveFormsModule,
            CommonModule,
            RouterModule,
            ButtonModule,
            TranslateModule,
            MessageModule,
            MessagesModule,
            TableModule,
            TooltipModule,
            ConfirmDialogModule,
            CardModule,
            DialogModule,
            NotificationsModule,
            ScrollPanelModule,
            TimelineModule,
            DividerModule,
            SharedModule,
            DataViewModule,
            PanelModule,
            DashboardRoutingModule,
            AvatarModule,
            NgxGaugeModule,
            RatingModule,
            ChartModule,
            KnobModule,
            ScUserMessageModule
        ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, {provide: LOCALE_ID, useValue: 'pt'}]
})
export class DashboardModule { }


